import { Injectable } from '@angular/core';
import { AngularFireMessaging } from "@angular/fire/messaging";
import { BehaviorSubject, Observable } from 'rxjs';
import { NotificationBody, NotificationMessage } from "../models/interfaces/notification-message.interface";
import { DatePipe } from '@angular/common';
import { TypeNotification } from '../models/enum/type-notification.enum';
import { News } from '../models/interfaces/news';
import { Event } from '../models/interfaces/event';
import { UserUtil } from '../utils/user.utils';
import { PushNotificationsUtil } from '../utils/push-notifications.utils';

@Injectable()
export class PushNotificationService {

  // @ts-ignore
  private notification$ = new BehaviorSubject<NotificationMessage>(undefined);

  constructor(
    private readonly afMessaging: AngularFireMessaging,
    private datePipe: DatePipe,
    private readonly userUtil: UserUtil,
    private readonly pushNotificationsUtil: PushNotificationsUtil
  ) { }

  setNotification(message: NotificationMessage): void {
    this.notification$.next(message);
  }

  getNotification(): Observable<NotificationMessage> {
    return this.notification$.asObservable();
  }

  requestFcmToken() {
    this.afMessaging.requestToken.subscribe(
      (token) => {
        if (token != null) {
          this.userUtil.addUserFcmToken(token);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  listenNotifications() {
    this.afMessaging.messages.subscribe((message: any) => {
      this.setNotification({
        body: this.isJson(message.notification.body) ? this.buildPushNotificationBody(message.notification) : message.notification.body,
        title: message.notification.title,
        isVisible: true,
      });
    });
  }

  enableChatNotifications(): void {
    this.pushNotificationsUtil.enableChatNotifications();
  }

  disableChatNotifications(): void {
    this.pushNotificationsUtil.disableChatNotifications();
  }

  get isChatNotificationsActive(): boolean {
    return this.pushNotificationsUtil.isChatNotificationsActive();
  }

  isJson(body: string) {
    if (body.includes('type')) {
      return true
    }
    return false
  }

  buildPushNotificationBody(notification: any): string {
    const body: NotificationBody = JSON.parse(notification.body)
    if (body.type === TypeNotification.NEWS) {
      const news = <News>body.data
      return news.title
    } else if (body.type === TypeNotification.EVENTS) {
      const events = <Event>body.data
      return this.datePipe.transform(events.startDate, 'dd/MM/YYYY') + ': ' + events.title
    } else {
      return ''
    }
  }
}
